
import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import useLogin from './useLogin';


const useDoor = () =>{
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { logout } = useLogin();

    const token = useSelector((state)=>state.user.itoken);
    //const iToken = useSelector((state)=>state.user.itoken);

    const HOST = process.env.REACT_APP_API_MIDDLEWARE_URL;

    const dispatch = useDispatch();

    const getDoors = async(onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.get(
            `${HOST}/api/v2/smartLocks?page=0&pageSize=200&orderDir=DESC&orderBy=id`,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              if(response.status === 401){
                logout();
              }
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            if(error.response?.status === 401){
                logout();
            }
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

     const editDoor = async(doorId,doorData,onSuccess,onError) =>{
        const headers = {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
        };
      try {
        setLoading(true);

        axios.put(
            `${HOST}/api/v2/smartLocks/${doorId}`,
            doorData,
          {
            headers,
          }
        ).then(
          (response) => {
            if(response.status === 200){
                onSuccess(response.data);
            }else{
              onError(`Errore, Riprova piu tardi Code:${response.status}`)
            }
          },
          (error) => {
            setError("Errore, Riprova piu tardi");
            onError(`Errore, Riprova piu tardi`)
          }
        ).finally(() => {setLoading(false)});
      }catch (error) {
        setError("Errore, Riprova piu tardi");
        onError(`Errore, Riprova piu tardi`)
      }

    }

    return {getDoors, editDoor, doorLoading:loading, doorError:error};
};

export default useDoor;